export type SearchOption = {
  kind: "hash" | "fuzzy-hash" | "name";
};

export interface SearchOptionsProps {
  value: SearchOption;
  onChange: (option: SearchOption) => void;
}

/**
 * Simple dropdown selector for search type.
 * The backend distinguishes hash algorithms by input length.
 */
export function SearchOptions({ value, onChange }: SearchOptionsProps) {
  function handleChange(event: Event) {
    const select = event.currentTarget as HTMLSelectElement;
    onChange({ kind: select.value as SearchOption["kind"] });
  }

  return (
    <div class="search-dropdown-row">
      <label for="search-type" class="search-dropdown-label">By:</label>
      <select
        id="search-type"
        class="search-dropdown-select"
        value={value.kind}
        onChange={handleChange}
      >
        <option value="hash">Hash</option>
        <option value="fuzzy-hash">Fuzzy Hash</option>
        <option value="name">Fuzzy Name</option>
      </select>
    </div>
  );
}
